import {useEffect, useRef, useState} from 'react';
import type {ExpiryCheckResult, SignalExpiryPolicy} from '../utils/signalExpiry';
import {checkAllExpiry} from '../utils/signalExpiry';

interface ExpiryParams {
    currentPrice: number;
    entryPrice: number;
    expectedHoldingUntil?: number | null;
    expectedHoldingBars?: number | null;
    signalFormedAt?: number | null;
    interval: string;
    zoneType?: string | null;
    zoneUpper?: number | null;
    zoneLower?: number | null;
    latestClose?: number;
    policy: SignalExpiryPolicy;
}

export function useSignalExpiry(
    params: ExpiryParams | null,
    enabled: boolean,
): ExpiryCheckResult {
    const [result, setResult] = useState<ExpiryCheckResult>({expired: false});
    const paramsRef = useRef(params);

    useEffect(() => {
        paramsRef.current = params;
    }, [params]);

    useEffect(() => {
        if (!enabled || !params) {
            setResult({expired: false});
            return;
        }

        setResult(checkAllExpiry(params));
    }, [enabled, params?.currentPrice, params?.entryPrice, params?.expectedHoldingUntil,
        params?.expectedHoldingBars, params?.signalFormedAt, params?.interval, params?.zoneType,
        params?.zoneUpper, params?.zoneLower, params?.latestClose,
        params?.policy.priceDeviationThreshold, params?.policy.maxCandleAge]);

    useEffect(() => {
        if (!enabled || !paramsRef.current) return;
        const check = () => {
            if (paramsRef.current) {
                setResult(checkAllExpiry(paramsRef.current));
            }
        };

        const timer = setInterval(check, 30000);
        return () => clearInterval(timer);
    }, [enabled]);

    return result;
}
